import React from 'react'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

interface IMileageReportingProps {
  print?: boolean
  useCarrierFilters: boolean
}

const MileageReportingDashboard: React.FC<IMileageReportingProps> = (props) => {
  const { useCarrierFilters } = props
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined
  const carrierId =
    useCarrierFilters && !isCarrierLogin()
      ? localStorage.getItem('carrierId') || undefined
      : undefined
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.MILEAGE}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
      fullHeight={!useCarrierFilters}
    />
  )
}
export default MileageReportingDashboard
